module.exports = __webpack_public_path__ + "static/img/honner2.c60a3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honner/honner2.png
// module id = 1exO
// module chunks = 0